module.exports = __webpack_public_path__ + "img/page404.ce6b8ea2.svg";